import axios from 'axios';
import apiBaseUrl from '@/config/api-base-url';

function uploadFile(path, file) {
  const formData = new FormData();
  formData.append('file', file);

  const uploadClient = axios.create({
    baseURL: apiBaseUrl,
    headers: {
      'x-api-key': 'def8e0041c8f4cc0918773d15b474a77'
    }
  });

  return uploadClient.post(`/files/upload/${path}`, formData);
}

export { uploadFile };